export default {
  about: {
    title: '公司简介',
    company: '北京龙讯旷腾科技有限公司',
    companyp: '龙讯旷腾是由领域知名科学家领衔的 AI for Science（AI4S）平台型企业。公司将材料计算与人工智能深度融合，创新构建了以“垂类材料大模型”为超级大脑、“材料研发智能体”为核心中枢的新一代产品矩阵。通过智能体自主规划并调用自研材料研发工具进行高效模拟与高通量筛选，公司将AI“干实验”体系与下游自动化实验设备深度融合，成功打造了“大模型设计预测—工具模拟验证—自动化合成测试—数据回流精调”的干湿实验闭环解决方案。目前，龙讯旷腾已服务超 200 家科研与产业客户，在 AI4S 与国产替代双重浪潮下，持续推动材料研发范式的深度智能化变革。',
//     companyp1: '“龙讯”于2015年在北京成立，公司的目标是为在材料模拟方面的科研团队提供最新的工具和技术，帮助广大科研人员解决相关的问题。',
//     companyp2: `“龙讯”将高速发展的计算技术、模拟方式、数学算法注入到强大的材料模拟工具之中，
//     从而帮助科研人员和工业研发人员去理解、设计和发现新材料。
//     我们研发了软硬件一体化的方案，为客户提供全方位的服务和支持；同时我们也为客户提供培训、合作会议等服务，使我们的客户和“龙讯”一起成长。`,
    team: '我们的团队',
    teamp: "核心团队具备丰富的行业履历，具有“材料物理理论+人工智能+先进制造”等学科交叉、理论与应用并重、软硬件并行的硬核背景。硕博高学历人才占公司技术与研发部门的 85% 以上，构筑了深厚的技术壁垒，致力于推动AI与材料模拟融合技术的创新突破与产业化应用。",
    teamt1: '创始人兼首席科学家  汪林望',
    teamp1: '现任中国科学院半导体研究所首席科学家。作为在材料计算领域深耕三十余年的国际领军人物，汪教授以其开创性的大尺度、多体系计算研究享誉全球。作为全球首位华人戈登·贝尔奖获得者，连续荣获美国 INCITE 项目奖项（2007-2018），入选美国物理学会会士，并曾在美国劳伦斯伯克利国家实验室担任高级研究员。迄今已发表 SCI 论文 400 余篇，学术总引用逾 40,000 次，h-index 高达 109；在 Elsevier 全球前 2% 科学家终身科学影响力榜单中，位列中国区第 185 位，并在物理与天文领域终身成就排名中高居第16位。汪教授曾于 2003 年荣获海外杰出青年基金，亦是 1985 年 CUSPEA（中美联合物理研究生项目）的杰出校友。汪教授卓越的学术生涯与标志性成果，奠定了他在世界计算物理学界的权威地位。',
    teamt2: 'CEO  田洪镇',
    teamp2: '2017 年毕业于北京航空航天大学。拥有多年材料模拟研究经验，已在国内外期刊上发表多篇 SCI 论文，包括一篇 AEM、两篇 PNAS 等高水平成果。带领团队先后开发了龙讯超算云平台 Mcloud、电池材料研发平台 BattSim、高性能集群管理平台 ClusterPro 等多个平台化产品。2024 年以来，在人工智能产品方向取得突破，主导开发了超智协同工作流编排平台 HyperFlow 及材料智能研发平台 IntelliMat ，极大丰富了公司产品矩阵，为公司在AI与材料交叉领域的布局奠定了坚实基础。',
//     teamp1: '“龙”之队由材料科学家、计算机科学家和硬件工程师组成。',
//     teamp2: `我们的团队成员是电子结构计算和算法研究领域的领导者，在新方法和软件工程方面有几十年的经验。
//     这也是“龙讯”成立的愿景：将我们对电子结构计算方面的研究成果和最新的研究进展带给我们的客户，使更多的人获益！`,
    solution: '我们的解决方案',
    solutionp1: '强大的 GPU 加速平面波密度泛函软件 PWmat',
    solutionp2: '我们对平面波密度泛函软件在GPU方面进行了深度优化，充分发挥了GPU的加速性能，无论在计算规模还是在计算速度上，都使第一性原理计算都有了质的飞越。',
    solutionp3: '软硬一体机，开箱即用',
    solutionp4: `通过不断对硬件的测试，我们将常见的模拟计算软件Quantum Espresso、Lammps-GPU、可视化软件VESTA预装到自主研发的“MSTATION”上面，
                 为客户提供开箱即用的解决方案，功能强大，真正做到人无我有，人有我快的体验。此外，和CPU集群相比，MSTATION具有高性价比、低功耗、低噪音等特点。`,
    solutionp5: '完善的售后培训和技术支持',
    solutionp6: '龙讯为客户提供有针对性的专业培训，保证客户在购买之后能迅速上手。有专门的客户群，为客户解答平时使用过程中遇到的各种问题，避免遇到问题无人咨询的情况，缩短客户科研周期。',
    investor: '投资机构',
  },
  companynew: {
    news: '公司动态'
  },
  academic: {
    title: '学术教育方案',
    material: '一站式材料计算服务',
    materialP1: `
          龙讯旷腾自主开发了第一性原理计算软件PWmat、PWmat前后处理工具软件PWkit、
          PWmat在线可视化提交任务软件Q-Flow、浏览器端在线原子尺度建模软件Q-Studio、开源机器学习力场软件PWmat-MLFF等软件产品,
          致力于为高校用户提供从原子尺度建模到材料性质计算、数据可视化以及使用培训的一站式材料计算服务，让用户可以快速轻松上手材料计算。
    `,
    materialP2: `
          同时龙讯旷腾也推出了预装所有上述软件产品的4卡GPU服务器Mstation，用户可开箱即用。
          除了一体机Mstation，龙讯旷腾还推出了SaaS化解决方案Mcloud。Mcloud是龙讯旷腾自建高性能集群和云桌面组成的云平台，
          云平台集成龙讯旷腾所有软件产品，租机时即可使用。针对上述软件产品，龙讯旷腾均有配套培训服务和售后支持服务，购买上述任何龙讯产品
          即可享受免费培训服务，培训包括基础课程、进阶课程和专题课程，适用不同基础用户。
    `,
    solution: '解决方案',
    solutionR0C1: '方案类型',
    solutionR0C2: '方案优势',
    solutionR1C1: '单独软件License',
    solutionR1C2: '免费安装和升级软件，提供软件使用培训和售后支持服务',
    solutionR2C1: '一体机Mstation',
    solutionR2C2: '预装龙讯所有软件产品，以及机器管理和作业调度软件，用户可开箱即用，提供培训和售后支持',
    solutionR3C1: '双机互联Mstation',
    solutionR3C2: '两台单机版Mstation直接ib网线互联组成轻量化的集群,具有高性价比特点，提供培训和售后支持',
    solutionR4C1: '集群化Mcluster',
    solutionR4C2: '由多台Mstation、存储服务器及管理节点组成，预装龙讯所有软件、集群管理软件及客户需求开源软件',
    solutionR5C1: '机时租赁Mcloud',
    solutionR5C2: '租赁龙讯超算云Mcloud机时即可使用所有龙讯软件产品，具有随租随用、资源丰富、可扩展性强等特点',
    app: '应用案例',
    partner: '合作高校',
  },
  industrial: {
    title: '行业解决方案',
    background: '行业背景',
    backgroundP1: `
    基于量子力学的第一性原理计算可以从原子尺度计算材料的性质，加深对材料特性的理解，
    为实验提供知道方向，将盲目试错变成理性设计，助力新材料研发，降低研发成本和周期。第一性原理计算已在学术界有30年的应用历史，
    渗透到材料研究的各个方面。近20年来，第一性原理计算在中国也有了长足的发展，相关论文数量呈指数级增长，材料计算在整个材料研发中占比高达20%，市场潜力巨大。
    `,
    demand: '行业需求',
    demandT1: '新能源',
    demandP1: `在碳中和与碳达峰大背景下，新能源是未来20-30年的一个主要工业发展方向，但无论是二次锂电池，还是水分解、氢储存等研究方向均有不同的技术问题，如高容量正负极材料筛选、
            水分解催化剂设计、氢储材料优化设计等，这些问题都需要借助量子力学从原子尺度给出合理的解决方案或建议，新能源属于原子领域，而非机械领域，需要原子尺度的计算模拟`,
    demandT2: '半导体',
    demandP2: `随着器件不断接近原子尺度，连续介质的特性不再成立，原子效应、量子效应明显，摩尔定律就要完结，电子器件不再是一个体材料的电子扩散输运的经典器件，而是一个充满量子效应、
            多物理现象、原子纳米尺度的器件。“More than Moore”时代将是一个研发投入更多的时代。对于半导体器件的研发，原子尺度的计算模拟是必不可少的`,
    demandT3: '化工催化',
    demandP3: `近年来，得益于理论计算的快速发展，基于原子尺度的计算模拟在催化领域的运用日益广泛，
            可帮助研发人员深入研究催化反应过程，更清楚地找到问题所在，解决反应过程中动态微观结构演变、反应路径等问题，助力工业制品的研发`,
    demandT4: '生物制药',
    demandP4: `靶向药的兴起，让小分子药物研发充满生机，疫情告诉我们，社会需要快速开发药物的能力，时间紧迫，生物制药行业已经有几十年分子计算的经验，
            但问题在于传统的材料模拟不够精确，所以如何提供计算精度和准确性是亟需解决的问题`,
    demandT5: '合金',
    demandP5: `合金材料覆盖工业方方面面，企业需要更符合行业需求的合金材料。铁、钛等自身具有结构相变的材料可设计性非常强，通过技术手段可改变其内部原子结构，
            使其强度等特性发生改变，而进行原子尺度的计算模拟，可以使材料内部性质的计算更加精确，提升合金材料的研发效率`,
    app: '应用案例',
    appT1: '案例1：提高高镍三元正极材料循环稳定性',
    appP1: `高镍三元材料由于具有较高的克容量而逐渐成为动力电池的首选材料。但是，在高镍材料的合成和充放电循环过程中容易出现大量的锂镍混排缺陷，导致材料容量快速衰减。
            元素掺杂可以有效改善锂镍混排问题，提高三元材料的容量。龙讯旷腾通过第一性原理计算方法帮助某正极材料公司进行了掺杂元素的筛选。`,
    appT2: '案例2：高镍三元锂正极材料电压平台及容量计算',
    appP2: `高镍三元锂离子电池正极材料LiNi<sub>1−x−y</sub>Co<sub>x</sub>Mn<sub>y</sub>O<sub>2</sub>（NCM）凭借比容量高、成本较低和安全性优良等优势，
            成为研究的热点，被认为是极具应用前景的锂离子动力电池正极材料。
            层状结构NCM中，镍是主要的氧化还原反应元素，因此，提高镍含量可以有效提高NCM的比容量。
            某锂电池材料公司重点发展磷酸铁锂和高镍三元材料，龙讯旷腾用第一性原理计算帮助其计算了高镍三元材料的电压平台和容量。
            通过高通量计算，寻找到了每个浓度下能量相对较低的结构，其平均能量相图揭示了反应过程中能量较稳定的相，计算了稳定性的电压和理论容量。`,
    appT3: '案例3：全固态电池正极包覆材料筛选',
    appP3: `固态电解质与正极材料直接接触时会发生反应，固态电解质被氧化，形成电阻性界面并增加电池阻抗，导致容量快速衰退。为寻找合适的正极包覆材料，抑制这些氧化反应发生，
            龙讯旷腾借助第一性原理计算，帮助某固态电池公司进行正极包覆材料筛选。`,
    appT4: '案例4：硫化物固态电解质筛选',
    appP4: `硫化物电解质相比于氧化物和聚合物电解质具有更高的离子电导率，但稳定性差。元素掺杂是解决硫化物电解质稳定性的一个重要手段，
            龙讯旷腾通过第一性原理计算和机器学习力场方法进行了掺杂元素和掺杂比例的筛选，
            帮助某固态电池公司找到了合适的掺杂元素及可能的配比范围。`,
    appT5: '案例5：CMOS器件模拟',
    appP5: `PWmatTransport采用量子散射态方法计算量子输运，与算法复杂度规模在O(N3)的NEGF方法不同，这种散射态方法可以直接计算给定能量的散射态。
            这种方法可以线性扩展系统大小，因此适用于大型系统的仿真。
            PWmatTransport已被用于模拟具有6nm沟道长度的实际CMOS器件，该体系包含5000个原子。同时，为了模拟真实器件，我们还开发了不同电极采用不同费米能级的非平衡自洽计算方法。`,
    appT6: '案例6：PWmat嵌入农机装备材料研发平台',
    appP6: `农机装备关键材料面临着高强化、耐磨性、耐蚀性、自主率的轴齿轮材料一致性等方面的优化，需要有效突破生产应用中的关键共性技术，提升我国农机制造业整体技术水平。
           龙讯旷腾PWmat能够得出材料性能数据（力学性能、成形性能、成分性能），将性能数据和材料企业提供的材料工艺生产信息交叉对比，加速设计验证新材料。
           PWmat嵌入研发平台不仅能够总结多种农机材料的共性性能要求和共性技术，提高农机材料（乃至机械材料）研发效率，还能探索材料信息平台整合研发的可能，
           和产业链其他企业合作形成材料研发全流程解决方案。`,
    appT7: '案例7：PWmat嵌入钢铁行业研究平台',
    appP7: `由于实验测量高温高压环境金属的相图成本较高、难度较大，产研界考虑通过计算材料的热力学性质进行完整和体系化了解，画出初步相图后就关键点进行实验确认。计算求解的原理为：
            通过求解不同结构的量子力学方程（第一性原理计算），得到材料的吉布斯自由能，确定相图的结构。
            在计算实践中，龙讯旷腾考虑材料本身能量、零点能、材料体积变化、原子振动熵、电子自旋方向熵、电子轨道排布熵等因素，构建了在压强、温度、磁排布等不同环境下计算相图的集成最优方案。
            在中国钢研院项目中，龙讯旷腾在不使用任何实验参数的情况下，仅通过利用以上计算流程得到了与实验相图趋势接近的Ti和Fe的计算相图。进一步利用极少的实验相变点数据，
            使用LDA与PBE交换关联泛函的校准、DFT+U校准等方法，修正密度泛函理论的第一性原理计算结果与实验的误差，得到在所有文献中与实验数据最为接近的第一性原理计算相图。`,
    partner: '合作企业',
  },
  cooperate: {
    banner: '公司简介',
    title: '我们的客户',
    cooperateR1C1: '中国科学院半导体研究所',
    cooperateR1C2: '中国科学院大学物理学院',
    cooperateR1C3: '浙江大学城市学院',
    cooperateR2C1: '浙江大学能源工程学院',
    cooperateR2C2: '中国科学院苏州纳米技术与纳米仿生研究所',
    cooperateR2C3: '中南大学物理与电子学院',
    cooperateR3C1: '华中科技大学光学与电子信息学院',
    cooperateR3C2: '复旦大学物理系',
    cooperateR3C3: '华南师范大学物理与电信工程学院',
    cooperateR4C1: '华南理工大学物理与光电学院',
    cooperateR4C2: '华南理工大学材料科学与工程学院',
    cooperateR4C3: '中国科学院近代物理研究所',
    cooperateR5C1: '湖南大学物理与微电子科学学院',
    cooperateR5C2: '北京科技大学新材料技术研究院',
    cooperateR5C3: '内蒙古大学物理学院',
    cooperateR6C1: '北京大学深圳研究生院',
    cooperateR6C2: '苏州大学能源学院',
    cooperateR6C3: '苏州大学材料学院',
    cooperateR7C1: '华东师范大学物理与电子科学学院',
    cooperateR7C2: '鲁东大学物理与光电工程学院',
    cooperateR7C3: '深圳大学电子科学与技术学院',
    cooperateR8C1: '韩国首尔大学',
    cooperateR8C2: '南方科技大学材料学院',
    cooperateR8C3: '南方科技大学物理学院',
    cooperateR9C1: '韩山师范学院材料系',
    cooperateR9C2: '吉林大学材料科学与工程学院',
    cooperateR9C3: '吉林大学物理学院',
    cooperateR10C1: '中原工学院理学院',
    cooperateR10C2: '武汉大学工业科学研究院',
    cooperateR10C3: '武汉大学机械与动力工程学院',
    cooperateR11C1: '山东大学信息科学与工程学院',
    cooperateR11C2: '南开大学物理学院',
    cooperateR11C3: '南京工业大学先进材料研究院',
    cooperateR12C1: '南京理工大学新型显示材料与器件重点实验室',
    cooperateR12C2: '中国计量大学光学与电子科技学院',
    cooperateR12C3: '中国科学院新疆理化技术研究所',
    cooperateR13C1: '北京信息科技大学理学院',
    cooperateR13C2: '西北大学物理学院',
    cooperateR13C3: '清华大学机械工程系摩擦学国家重点实验室',
    cooperateR14C1: '清华大学化学系',
    cooperateR14C2: '三峡大学材料与化工学院',
    cooperateR14C3: '西南科技大学物理学院',
    cooperateR15C1: '河北大学化学与环境科学学院',
    cooperateR15C2: '济南大学化学院',
    cooperateR15C3: '北卡罗来纳大学夏洛特分校',
    cooperateR16C1: '福州大学材料学院',
    cooperateR16C2: '河北工业大学材料学院',
    cooperateR16C3: '郑州大学化学与分子工程学院',
    cooperateR17C1: '中国科学院长春光学精密机械与物理研究所',
    cooperateR17C2: '新疆大学物理科学与技术学院',
    cooperateR17C3: '人民大学物理学院',
    cooperateR18C1: '东北大学材料学院',
    cooperateR18C2: '东北大学轧制技术及连轧自动化国家重点实验室',
    cooperateR18C3: '中山大学物理学院',
    cooperateR19C1: '广东工业大学物理与光电工程学院',
    cooperateR19C2: '南洋理工大学能源研究所',
    cooperateR19C3: '西安电子科技大学',
    cooperateR20C1: '北京化工大学数理学院',
    cooperateR20C2: '深圳信息职业技术学院',
    cooperateR20C3: '重庆邮电大学理学院',
    cooperateR21C1: '中国矿业大学物理学院',
    cooperateR21C2: '西安建筑科技大学理学院',
    cooperateR21C3: '中国科学院微电子研究所',
    cooperateR22C1: '苏州热工研究所',
    cooperateR22C2: '。。。',
  },
  contract: {
    banner: '联系我们',
    title: '一体化全方位服务',
    sale: '销售',
    saleP1: '“龙讯”主要销售MSTATION、MCLUSTER及PWmat软件包，同时还提供计算机时服务。具体细节请联系我们的销售及售前经理。',
    support: '售后',
    supportP1: '“龙讯”还提供完善的售后服务，具体细节请联系我们的客服。',
    cooperate: '合作',
    cooperateP1: '“龙讯”还提供平面波相关数值软件开发的服务，同时也希望与广大科研人员共同推动国产量子计算模拟软件的发展。',
    contractDetails: '联系方式',
    salePhone: '销售电话：',
    supportPhone: '售后电话：',
    mail: '邮箱：',
    wechat: '微信公众号：',
    wechatText: '公众号搜索“PWmat1”',
    address: '地址：',
    addressText: '北京市海淀区学清路8号科技财富中心A座908室',
  },
  join: {
    banner: '加入我们',
    title: '招贤纳士',
    joinP1: `几年来通过不断推出和完善适应市场的优秀产品和优质服务，
    “龙讯”已经成功在材料模拟计算软件之中占据一席之地。为了提供国内乃至国际上一流的高性能材料模拟计算服务，
    推动国产材料模拟计算软件的发展，现诚邀广大志同道合之士加入龙讯这个大家庭。（本招聘长期有效）`,

    positionAname: '电解液配方全流程研发工程师',
    positionAtitle: '岗位职责：',
    positionAtext1: '1. 独立负责动力电池、储能电池电解液全新体系正向开发，优化溶剂、锂盐、添加剂配比，适配高压、高低温、长循环、高安全等场景，搭建标准化研发体系。',
    positionAtext2: '2. 结合电化学机理+材料仿真技术，解决电池循环衰减、胀气、低温容量跳水、高压不稳定等核心问题，完成配方迭代与性能升级。',
    positionAtext3: '3. 统筹实验验证、性能测试、失效分析，输出闭环解决方案；负责小试工艺优化与技术导入，保障量产稳定性。',
    positionAtext4: '4. 跟踪行业前沿技术，布局专利知识产权；对接客户与产学研资源，赋能团队技术提升，输出新品研发规划。',
    positionAtext5: '5. 硕士及以上，电化学、材料、应用化学、化工等相关专业，博士优先。',
    descriptionA: '核心经验：',
    descriptionAtext1: '1. 8年以上电解液全流程研发经验，3年以上技术负责人/专家岗位经验，具备从0-1搭建电解液研发实验室、搭建测试体系与实验规范的完整经验；熟悉电池电解液研发-中试-量产全链条，头部电解液/电池企业从业经历优先。',
    descriptionAtext2: '2. 精通电解液体系搭配机理，熟练各类添加剂应用，擅长性能优化与失效分析；可独立操盘新项目、解决量产技术难题；',
    descriptionAtext3: '3. 具备体系化研发思维、良好的专利撰写与跨部门协作能力，有技术攻坚和团队赋能意识。',

    positionBname: '售前工程师（全职）',
    positionBtitle: '岗位职责：',
    positionBtext1: '1. 负责协助销售面向客户进行前期技术交流并分析客户需求； 负责与客户间的技术答疑、技术确认；',
    positionBtext2: '2.	能理解用户需求和痛点，根据需求可以设计解决方案；',
    positionBtext3: '3.	根据公司产品属性及功能引导客户，持续挖掘需求并提供解决方案思路；',
    positionBtext4: '4.	负责与公司内部技术部开发部的需求确认与技术实现路径对接。',
    descriptionB: '任职要求：',
    descriptionBtext1: '1. 博士及以上，计算机、材料类、物理类专业；',
    descriptionBtext2: '2. 有动力/储能类锂电池公司工作经验；',
    descriptionBtext3: '3. 至少熟悉一种原子尺度材料模拟软件，例如PWmat、VASP；',
    descriptionBtext4: '4. 沟通能力强，踏实肯干。',

    positionCname: '公司福利：',
    positionCtext1: '有竞争力的薪资      大牛带队      弹性工作      租房补贴',
    positionCtext2: '零食下午茶      节日福利      专业技术培训及零基础培训',
    positionCtext3: '五险一金（12%公积金）      加班打车及餐补',
    positionCtext4: '日常餐费补贴      各种礼金带薪年假',

    positionDname: '公司优势',
    positionDtext1: '与IT公司相比，作为理论计算的硕士，龙讯旷腾更能发挥你的专业优势，同时工作强度不大，绝对不是996',
    positionDtext2: '搞计算，写程序，本行不丢，未来转互联网企业很容易',
    positionDtext3: '初创公司，早来早占坑，早拿股份，早带团队',
    positionDtext4: '成为精通物理和计算机的复合人才，通过我司培训迅速掌握一区期刊发文章套路',

    positionEname: '简历投递',
    positionEtext1: '投递邮箱',

    positionFname: '销售经理（全职）',
    positionFtitle: '岗位职责：',
    positionFtext1: '1. 负责公司业务层面新客户开发以及老客户维护；',
    positionFtext2: '2.	负责公司软件产品的推广和销售，承担业绩指标；',
    positionFtext3: '3.	参与制定销售计划，形成销售策略、市场打法；',
    positionFtext4: '4.	有科研类软件销售经验者优先考虑；',
    positionFtext5: '5. 有行业深耕和自带资源者优先考虑。',
    descriptionF: '任职要求：',
    descriptionFtext1: '1. 物理、材料以及半导体等相关专业，本科及以上学历；',
    descriptionFtext2: '2. 有软硬件销售经验，科研类市场资源；',
    descriptionFtext3: '3. 肯吃苦、目标导向、高度的工作热情，良好的团队合作精神；',
    descriptionFtext4: '4. 对第一性原理计算、材料模拟计算有所了解。',

    positionGname: '大客户经理（全职）',
    positionGtitle: '岗位职责：',
    positionGtext1: '1、客户开发与维护：负责半导体、新材料等To B企业，以及高校、科研院所、政企科研平台等To G大客户的开发、洽谈与合作落地；维护存量核心客户，深耕客情关系，持续提升客户粘性与复购率。',
    positionGtext2: "2、销售落地与业绩达成：承担公司销售指标，负责科研软硬件产品大客户推广、商务谈判、报价签约、订单跟进等全流程工作，保质保量完成年度、季度、月度销售目标。",
    positionGtext3: '3、市场与策略运营：结合To B、To G行业市场特点及客户需求，配合制定大客户销售策略与拓客打法，深挖客户长期合作价值，拓展多元化合作模式。',
    positionGtext4: '4、资源整合落地：依托自身To B、To G行业及政企渠道资源，快速推进大客户项目落地；持续整合沉淀优质行业资源，搭建可复用的大客户渠道体系。',
    positionGtext5: '5、项目协同交付：精准挖掘客户科研采购、软件部署等核心需求，联动技术、售后团队完成方案对接、技术答疑与项目交付，保障客户满意度。',
    positionGtext6: '6、市场信息调研：收集行业动态、科研政策、客户需求及竞品信息，复盘总结，为市场策略优化提供参考。',
    descriptionG: '任职要求：',
    descriptionGtext1: "1、学历背景：本科及以上学历，物理、材料、半导体、新能源等理工科相关专业优先。",
    descriptionGtext2: '2、经验与资源：具备优质To B、To G大客户及渠道资源（高校、科研院所、半导体/新材料企业、政企科研平台等）；拥有2年以上科研软硬件销售经验，熟悉科研市场商务流程。',
    descriptionGtext3: '3、专业能力：了解第一性原理计算、材料模拟计算等相关科研知识，可独立完成需求对接、方案讲解与商务洽谈。',
    descriptionGtext4: '4、综合素养：目标导向、抗压能力强，具备优秀的大客户谈判、客情维护与资源整合能力，擅长政企及企业端大客户深度运营。',
    descriptionGtext5: '5、职业特质：工作热情高、执行力强，吃苦耐劳、善于复盘，具备良好的团队协作能力与职业操守。',
    priorityG: '优先条件',
    priorityGtext1: '1、自带高校、科研院所、政企采购、半导体/新材料头部企业等To B/To G核心资源者优先；',
    priorityGtext2: "2、有科研软硬件大客户销售成功案例及成熟业绩者优先；",
    priorityGtext3: '3、熟悉科研项目招投标、政企采购流程者优先。',

    positionHname: 'AI开发研究员 （实习/全职）',
    positionHtitle: '岗位职责：',
    positionHtext1: '1.负责将AI技术应用在垂直领域，对传统机器学习与大语言模型有一定的概念理解，对智能体开发有一定经验或哲学理解。',
    positionHtext2: "2.具备基础的全栈代码能力，前端React、Vue，后端Python或JavaScript",
    positionHtext3: '3.具有一定的AI产品思维，了解并跟踪现有行业AI产品和技术最新状态，为公司引入新的AI应用场景。',
    positionHtext4: '4.思想活跃，乐于参与新产品、新技术的讨论。',
    descriptionH: '任职要求：',
    descriptionHtext1: "1、计算机科学、人工智能、统计学、材料科学专业优先，本科及以上学历接受应届硕士；",
    descriptionHtext2: '2、具备问题解决能力，我们不是在找前端或者后端软件工程师，而是AI应用开发研究员，拥有主动提出思路并全栈解决的能力，而不是由我们给出具体解题思路和详细需求，只负责代码实现。（不需要传统螺丝钉）',
    descriptionHtext3: '3、 强学习能力，代码能力可以弱，但一定具有强学习能力，能够借助AI工具快速上手。',
    priorityH: '加分项：',
    priorityHtext1: '1、材料科学、凝聚态物理等专业',
    priorityHtext2: "2、材料计算或材料与AI交叉方向出身",
    priorityHtext3: '3、AI工具高度使用者，能够熟练使用AI编辑器提高项目代码编写速度',
    priorityHtext4: '4、项目书、标书撰写能力，PPT制作能力',

    positionJname: '高管管培生（CEO助理）（全职）',
    positionJtitle: '岗位职责：',
    positionJtext1: '1、协助CEO跟进材料、凝聚态物理、材料AI交叉方向核心项目，统筹进度、梳理问题、落地事项；',
    positionJtext2: "2、独立负责科研项目书、政企标书、方案报告的撰写、优化与打磨；",
    positionJtext3: '3、制作高端商务、项目汇报、路演展示PPT，适配各类对外对内汇报场景；',
    positionJtext4: '4、熟练使用各类AI编辑器、AI代码辅助工具，赋能代码编写、数据整理、方案提效；',
    positionJtext5: '5、对接协调各团队及合作方，做好会议、事务、信息统筹同步，落地CEO交办专项工作。',
    descriptionJ: '任职要求：',
    descriptionJtext1: "1、硕士及以上学历，材料科学、凝聚态物理等相关专业；",
    descriptionJtext2: '2、深耕材料计算、材料与AI交叉方向，有相关项目/科研经历，懂前沿技术逻辑。',
    descriptionJtext3: '3、 强学习能力，代码能力可以弱，但一定具有强学习能力，能够借助AI工具快速上手。',
    priorityJ: '岗位优势',
    priorityJtext1: '1、跟随CEO，接触顶层战略与高端资源，全方位提升商业、统筹、决策认知；',
    priorityJtext2: "2、立足AI+新材料前沿赛道，积累稀缺技术与项目经验；",
    priorityJtext3: '3、一站式锻炼技术理解、文案、汇报、商务统筹综合能力，发展路径多元；',
    priorityJtext4: '4、专属高管带教，管培快速晋升通道，核心业务优先操盘机会。',
    kernelJ: '核心能力',
    kernelJtext1: '1、重度AI工具使用者，熟练用AI辅助代码编写、优化及各类工作提效；',
    kernelJtext2: "2、具备标书、项目书、方案文案独立撰写能力，逻辑清晰、善于提炼亮点；",
    kernelJtext3: '3、可独立制作汇报PPT',

    positionKname: '项目研究员（全职/实习）',
    positionKtitle: '岗位职责：',
    positionKtext1: '1、AI赋能材料技术攻关：结合第一性原理、分子动力学、量子输运、蒙特卡罗等材料模拟方法，运用机器学习、AI势函数、智能建模等AI技术，解决锂电池、半导体、金属合金领域的产业技术难题，实现材料结构优化、性能预测与工艺迭代的智能化升级。',
    positionKtext2: "2、搭建智能化解决方案管线：依托AI算法与多尺度计算体系，针对三大材料领域行业需求，搭建可复用、可迭代的标准化智能研发方案管线，优化仿真精度与研发效率，输出适配不同产业场景的技术方案。",
    positionKtext3: '3、定制化需求方案落地：精准拆解企业研发、生产需求，结合AI+材料计算技术能力，独立完成技术路径规划与方案设计，推进定制化解决方案产业化落地。',
    positionKtext4: '4、技术与算法迭代优化：结合三大材料领域特性，持续优化机器学习模型、AI势函数与智能仿真算法，提升AI技术在材料设计、缺陷分析、性能优化中的应用精度与适配性。',
    descriptionK: '任职要求：',
    descriptionKtext1: "1、学历与背景：硕士及以上学历，材料、物理、微电子、电化学、计算化学、人工智能等相关专业，具备锂电池、半导体、金属合金任一或多领域材料模拟计算研发经验。",
    descriptionKtext2: '2、工具能力：熟练掌握PWmat、VASP、QE、LAMMPS等任一主流材料模拟计算软件，可独立完成多尺度仿真计算工作。',
    descriptionKtext3: '3、核心AI能力（必备）：掌握机器学习、AI材料势函数、量子输运建模、蒙特卡罗算法等交叉技术，具备AI模型训练、优化及落地应用能力，可依托AI赋能材料研发全流程。',
    descriptionKtext4: "4、方案能力：具备良好的需求拆解、技术分析和方案设计能力，可独立完成企业技术需求解决方案的搭建与落地。",
    descriptionKtext5: '5、综合素质：工作认真负责、主动性强，具备优秀的沟通协作、逻辑思维与技术攻关能力，可适配多领域交叉项目研发。',
    descriptionKtext6: '6、优先条件：具备多材料领域复合研发经验，拥有AI势函数开发、机器学习模型迭代、量子智能仿真开发经验者优先。',
    priorityK: '岗位概述',
    priorityKtext1: '本岗位为AI+先进材料交叉研发岗，聚焦锂电池、半导体器件、金属合金三大核心领域，依托多尺度材料模拟计算与人工智能技术，面向产业实际需求开展技术攻关，搭建智能化研发方案管线，落地企业定制化技术方案，赋能材料研发高效化、智能化升级。',

    positionLname: '半导体工艺模拟研究员',
    positionLtitle: '岗位职责：',
    positionLtext1: '1. 负责先进半导体制程工艺仿真研究，围绕光刻、离子注入、刻蚀、薄膜沉积、退火等核心工艺，开展工艺机理建模、仿真计算与数据分析，搭建高精度工艺仿真模型。',
    positionLtext2: '2. 参与公司自研Q-Flow、PWmat等仿真软件的模块迭代、算法优化与工艺场景适配，持续提升国产仿真工具的精度与工程实用性。',
    positionLtext3: '3. 对接晶圆厂工艺研发需求，针对先进制程工艺偏差、良率及器件性能问题，通过仿真复盘机理、定位症结，输出优化方案与专业分析报告。',
    positionLtext4: '4. 跟踪行业先进工艺与仿真技术趋势，开展新工艺、新仿真模型的预研落地，推进前沿技术工程化应用。',
    positionLtext5: '5. 负责项目仿真验证、数据复盘与技术沉淀，撰写技术文档、测试报告，配合项目对接与技术落地工作。',
    descriptionL: '任职要求：',
    descriptionLtext1: '1. 硕士及以上学历，微电子、半导体物理、材料物理、凝聚态物理、集成电路等相关专业，优秀应届生、博士及1-3年相关从业者均可。',
    descriptionLtext2: '2. 掌握半导体物理基础，熟悉CMOS、功率半导体等主流器件结构及完整制造工艺流程与核心机理；',
    descriptionLtext3: '3. 熟悉TCAD工艺/器件仿真逻辑，会使用Sentaurus、Silvaco、PWmat、VASP等任意一款仿真工具者优先；',
    descriptionLtext4: '4. 掌握Python/Fortran/C++任意一种编程语言，具备独立仿真建模、数据处理与结果分析能力；',
    descriptionLtext5: '5. 了解密度泛函理论、分子动力学等模拟方法，有原子尺度仿真、半导体工艺仿真项目经验者优先。',

    positionMname: '有限元偏微分方程研究员',
    positionMtitle: '岗位职责：',
    positionMtext1: '1. 针对半导体工艺、器件仿真等工业场景，开展各类偏微分方程数值求解、算法建模及精度优化工作。',
    positionMtext2: '2. 负责有限元核心算法研发迭代，优化网格剖分、数值离散、边界处理、收敛性等核心模块，提升仿真求解精度与稳定性。',
    positionMtext3: '3. 优化自研仿真软件有限元求解器，解决TCAD仿真、多物理场耦合场景下求解慢、不收敛等核心问题。',
    positionMtext4: '4. 调研前沿数值计算算法，开展新模型、新技术预研，落地高效工业仿真计算方案。',
    positionMtext5: '5. 完成算法验证、测试复盘，撰写技术文档，配合团队完成模块集成与工程落地。',
    descriptionM: '任职要求：',
    descriptionMtext1: '1. 硕士及以上学历，计算数学、应用数学、计算力学、物理、微电子等相关专业，应届生、博士或1-3年相关研发经验均可。',
    descriptionMtext2: '2. 精通有限元算法、偏微分方程数值解法，熟悉主流数值计算方法；',
    descriptionMtext3: '3. 掌握数值离散、网格处理、迭代求解、误差分析等核心技术；',
    descriptionMtext4: '4. 熟练使用C/C++、Fortran、Python任一语言，可独立完成算法实现与调试；',
    descriptionMtext5: '5. 熟悉PETSc、FEniCS、COMSOL等数值库或仿真工具者优先；',
    descriptionMtext6: '6. 有半导体仿真、多物理场耦合、求解器研发经验者优先。',

  }
}